import plur from "plur";
import { Button, Flex, ModalV2, QueryLoader } from "@jsq/ds/core";
import { FormSelect } from "@jsq/ds/forms";
import { useFetchCanopyRolesData } from "~/pages/UserAndRoles/CanopyRolesPage/hooks";
import { SPACING } from "~/styles/variables";
import { ViewRoles } from "../../UserDetails/components/AddRole/components/ViewRoles";

export const AddRoleModal = ({
  showModal,
  onHide,
  handleSubmit,
  isSubmitting,
  count,
}: {
  showModal: boolean;
  onHide: () => void;
  isSubmitting: boolean;
  handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
  count?: number;
}) => {
  const { rowData, useGetGroupsQueryResult } = useFetchCanopyRolesData();

  const modalTitle = `Add Canopy role ${count ? `to ${count} ${plur("user", count)}` : ""}`;

  return (
    <ModalV2
      title={modalTitle}
      description={<ViewRoles />}
      isCentered
      show={showModal}
      onHide={onHide}
    >
      <ModalV2.Body>
        <QueryLoader result={useGetGroupsQueryResult}>
          <FormSelect
            full
            multiple
            name="roles"
            placeholder="Select Canopy role..."
            matchFromStart={false}
          >
            <FormSelect.Section>
              {rowData.map((r) => (
                <FormSelect.Option value={r.id} key={r.id}>
                  {r.title}
                </FormSelect.Option>
              ))}
            </FormSelect.Section>
          </FormSelect>
        </QueryLoader>
      </ModalV2.Body>
      <ModalV2.Footer>
        <Flex
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-end"
          gap={SPACING.MEDIUM}
        >
          <Button variant="neutral" onClick={onHide}>
            Cancel
          </Button>
          {/** @ts-expect-error the onClick function won't accept the handleSubmit from formik. Another DS issue */}
          <Button onClick={handleSubmit} disabled={isSubmitting}>
            {modalTitle}
          </Button>
        </Flex>
      </ModalV2.Footer>
    </ModalV2>
  );
};
